import { render, staticRenderFns } from "./SigDefResponseForm.vue?vue&type=template&id=5baa5d54&scoped=true"
import script from "./SigDefResponseForm.vue?vue&type=script&lang=js"
export * from "./SigDefResponseForm.vue?vue&type=script&lang=js"
import style0 from "./SigDefResponseForm.vue?vue&type=style&index=0&id=5baa5d54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baa5d54",
  null
  
)

export default component.exports